module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_ack_r1.htm"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_int_r1.htm"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400187_comman.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c01_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("SOUTHERN APPALACHIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c02_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("BREAKFAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c03_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("APPETIZERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c04_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("SOUPS "), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" SALADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c05_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("VEGETABLES "), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" BEANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c06_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("BREADS, MUFFINS, ROLLS, "), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" BISCUITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c07_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("MEATS, FISH, "), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" SEAFOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c08_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("DESSERTS, COOKIES, CAKES, "), _c('span', {
    staticClass: "small01"
  }, [_vm._v("AND")]), _vm._v(" TEA CAKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c09_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("BEVERAGES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_c10_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small01"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_vm._v("COUNTRY STORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400187_comman.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_bm1_r1.htm"
    }
  }, [_vm._v("SOURCES "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" RESOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781449400187_epub_bm2_r1.htm"
    }
  }, [_vm._v("METRIC CONVERSIONS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" EQUIVALENTS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d92ca56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400187_epub_toc_r1.vue
// module id = 75
// module chunks = 0